import BaseModel from '../../../../base/base_model';
import {KEY_NAME} from '../../native/native_const';
import _ from "../../../../utils/underscore";
import {DEEP_LINK_HYBRID} from "./deep_link_hybrid_consts";


class DeepLinkModel extends BaseModel {

    static CLASS = 'DeepLinkModel';
    _deepLinkObject = {};


    /*
     * init the params to be an json object.
     * @params is string from web.config
     * @params is json object from html
     */
    init(params) {
        super.init(params);
    }

    updateData(data) {
        this._deepLinkObject = this.extractDeepLinkObject(data);
    }

    getDeepLinkObject(){
        return this._deepLinkObject;
    }

    extractDeepLinkObject(data) {
        const {[KEY_NAME.TYPE]: type, ...deepLinkObject} = data;

        if(type === DEEP_LINK_HYBRID.TYPE){
            if(_.isObject(deepLinkObject))
                return deepLinkObject;

            return _.safeJSONandDecode(deepLinkObject);
        }
    }

}

export default DeepLinkModel;